// Single source of truth for all promotional offers.
// Edit prices here → they propagate everywhere on the site.
import { uns } from "@/lib/uns";

const offerImage = (id) => {
  const { src, srcSet } = uns(id, { w: 1000, widths: [480, 800, 1000, 1400] });
  return { image: src, imageSrcSet: srcSet };
};

export const specials = [
  {
    id: "brake-special",
    slug: "brake-special",
    active: true,
    expiresOn: null,
    category: "brakes",
    title: "Brake Service Special",
    price: "$119",
    priceNote: "per axle, starting at",
    wasPrice: null,
    badge: "Limited Time",
    ...offerImage("photo-1580273916550-e323be2ae537"),
    imageAlt: "Close-up of a new brake rotor and caliper assembly on a lifted vehicle",
    description:
      "Front or rear brake service to get you stopping safely again.",
    includes: [
      "Premium brake pads installed",
      "Rotor inspection",
      "Brake system inspection",
      "Road test",
    ],
    finePrint:
      "Per axle. Most vehicles. Pads only — rotor resurfacing or replacement, calipers, and hardware additional if needed. Not valid with other offers.",
    ctaText: "Book This Service",
    ctaLink: "/#schedule",
    bookingService: "Brake Pads Replacement",
  },
  {
    id: "oil-conventional",
    slug: "oil-conventional",
    active: true,
    expiresOn: null,
    category: "oil",
    tier: "Conventional",
    title: "Conventional Oil Change",
    price: "$49.99",
    priceNote: null,
    wasPrice: null,
    badge: null,
    ...offerImage("photo-1489824904134-891ab64532f1"),
    imageAlt: "Classic vehicle parked — reliable everyday oil change for older engines",
    description:
      "Reliable protection for older engines and standard driving.",
    includes: [
      "Up to 5 quarts conventional oil",
      "New oil filter",
      "Multi-point inspection",
      "Fluid top-off",
    ],
    finePrint:
      "Up to 5 quarts. Most vehicles. Additional quarts, specialty filters, and disposal fees extra.",
    ctaText: "Book This Service",
    ctaLink: "/#schedule",
    bookingService: "Oil Change",
  },
  {
    id: "oil-semi-synthetic",
    slug: "oil-semi-synthetic",
    active: true,
    expiresOn: null,
    category: "oil",
    tier: "Semi-Synthetic",
    title: "Semi-Synthetic Oil Change",
    price: "$64.99",
    priceNote: null,
    wasPrice: null,
    badge: "Most Popular",
    ...offerImage("photo-1487754180451-c456f719a1fc"),
    imageAlt: "Technician replacing an oil filter under the hood",
    description:
      "A step up in protection for daily drivers and higher-mileage vehicles.",
    includes: [
      "Up to 5 quarts synthetic blend",
      "New oil filter",
      "Multi-point inspection",
      "Fluid top-off",
    ],
    finePrint:
      "Up to 5 quarts. Most vehicles. Additional quarts, specialty filters, and disposal fees extra.",
    ctaText: "Book This Service",
    ctaLink: "/#schedule",
    bookingService: "Oil Change",
  },
  {
    id: "oil-full-synthetic",
    slug: "oil-full-synthetic",
    active: true,
    expiresOn: null,
    category: "oil",
    tier: "Advanced Full Synthetic",
    title: "Advanced Full Synthetic Oil Change",
    price: "$94.99",
    priceNote: null,
    wasPrice: null,
    badge: "Best Protection",
    ...offerImage("photo-1580654712603-eb43273aff33"),
    imageAlt: "Modern performance vehicle — full synthetic oil for turbocharged engines",
    description:
      "Maximum protection and longest intervals for modern and turbocharged engines.",
    includes: [
      "Up to 5 quarts full synthetic",
      "New premium oil filter",
      "Multi-point inspection",
      "Fluid top-off",
    ],
    finePrint:
      "Up to 5 quarts. Most vehicles. Additional quarts, specialty filters, and disposal fees extra.",
    ctaText: "Book This Service",
    ctaLink: "/#schedule",
    bookingService: "Full Synthetic Oil Change",
  },
];

export const activeSpecials = () => specials.filter((s) => s.active !== false);
export const bySlug = (slug) => specials.find((s) => s.slug === slug);

// Oil comparison table config — placeholders for shop owner to fill in.
export const oilComparison = {
  tiers: ["Conventional", "Semi-Synthetic", "Advanced Full Synthetic"],
  highlightIndex: 1,
  rows: [
    { label: "Oil Type", values: ["Conventional", "Synthetic Blend", "Full Synthetic"] },
    { label: "Price", values: ["$49.99", "$64.99", "$94.99"] },
    {
      label: "Recommended Interval",
      values: [
        "[Shop to confirm]",
        "[Shop to confirm]",
        "[Shop to confirm]",
      ],
    },
    {
      label: "Best For",
      values: [
        "Older engines, standard driving",
        "Daily drivers, higher-mileage vehicles",
        "Modern and turbocharged engines",
      ],
    },
    { label: "Filter Included", values: ["New oil filter", "New oil filter", "New premium oil filter"] },
    { label: "Multi-Point Inspection", values: ["Included", "Included", "Included"] },
  ],
};
